<section>
    <form [formGroup]="formGroup">
        <div class="form-section">
            <div class="row margin-top-20">
                <div class="col-md-9">
                    <h2 class="title">CONNECTED APPS</h2>
                </div>
                <div class="col-md-3">
                    <a class="btn btn-primary" (click)="showAddConnectedAppModal()">{{ integrationProperty ? 'EDIT' : 'ADD' }} CONNECTED APP</a>
                </div>
            </div>
            <ng-container *ngIf="integrationProperty; else noIntegration">

                <div class="row">
                    <div class="col-md-3">
                        <label>Integrated Application</label>
                    </div>
                    <div class="col-md-6">
                        <span>{{integrationProperty?.integrationName}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>API Credentials</label>
                    </div>
                    <div class="col-md-6">
                        <span>{{integrationProperty?.integrationCredentialName}}</span>
                    </div>
                </div>
                <div class="row margin-bottom-20">
                    <div class="col-md-3">
                        <label>Association ID/Code</label>
                    </div>
                    <div class="col-md-6">
                        <span>{{integrationProperty?.externalPropertyCode}}</span>
                    </div>
                </div>
            </ng-container>
            <ng-template #noIntegration>
                <div class="row">
                    <div class="col-md-6">
                        <label> No Integrations have been setup.</label>
                    </div>
                </div>
            </ng-template>
        </div>
    </form>

    <sp-add-connected-app-modal #addConnectedAppModal 
        [propertyId]="property.propertyId">
    </sp-add-connected-app-modal>
</section>

